// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"615":"css/admin-app.6977","8724":"css/app.6977"}[chunkId] + ".css";
};